export default __webpack_public_path__ + "static/media/union2.3891c9ad.svg";